<script lang="ts">
  import { onDestroy, onMount } from "svelte";
  import type { Banner as BannerData } from "$lib/gql/genCms/codegen";
  import Banner from "../Banner.svelte";
  import { fade } from "svelte/transition";
  import { createEventDispatcher } from "svelte";

  export let banners: BannerData[];

  let activeBanner = 0;
  let displayTime = 6000;
  let wrapperEl: any;
  let timer: any;

  export let bannerHasLinks: boolean;

  onMount(() => {
    startTimer();
  });

  const startTimer = () => {
    if (banners.length > 1) {
      timer = setTimeout(updateActiveBanner, displayTime);
    }
  };

  const stopTimer = () => {
    if (typeof timer === "number") {
      clearTimeout(timer);
    }
  };

  const updateActiveBanner = () => {
    activeBanner++;
    if (activeBanner >= banners.length) {
      activeBanner = 0;
    }
    timer = setTimeout(updateActiveBanner, displayTime);
  };

  const dispatch = createEventDispatcher();

  const closeBanner = () => {
    dispatch("closeBanner");
    wrapperEl && wrapperEl.parentNode.removeChild(wrapperEl);
    stopTimer();
  };

  onDestroy(() => {
    stopTimer();
  });
</script>

<style lang="scss">
  .banner-wrapper {
    position: relative;
    z-index: 1;
    margin-bottom: -1px;
    height: 56px;

    &.bannerHasLinks {
      height: 71px;
    }

    @include breakpoint(lg) {
      height: 40px;

      &.bannerHasLinks {
        height: 40px;
      }
    }

    &--banner {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 100%;
    }
  }
</style>

<!-- svelte-ignore a11y-no-noninteractive-tabindex -->
<div
  class="banner-wrapper"
  bind:this={wrapperEl}
  class:bannerHasLinks
  on:mouseenter={stopTimer}
  on:mouseleave={startTimer}
  role="marquee"
  tabindex="0"
>
  {#key activeBanner}
    <div class="banner-wrapper--banner" transition:fade>
      <Banner bannerData={banners[activeBanner]} on:closeBanner={closeBanner} />
    </div>
  {/key}
</div>
